import { render } from "./index.vue?vue&type=template&id=165f319c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=165f319c&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__